import { render, staticRenderFns } from "./CancelForm.vue?vue&type=template&id=4899f8da"
import script from "./CancelForm.vue?vue&type=script&lang=js"
export * from "./CancelForm.vue?vue&type=script&lang=js"
import style0 from "./CancelForm.vue?vue&type=style&index=0&id=4899f8da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports